import {DateTime} from 'luxon';

export const age = (birthdate: number)=> {
  const birth = DateTime.fromMillis(birthdate);
  const age = DateTime.now().diff(birth, 'years').years;
  return Math.floor(age);
}

export const birthdate = (age: number) => {
  return DateTime.now().minus({year: age}).toMillis();
}

//


